const ARCHIVE_EXTENSION = /\.(zip|rar|7z|tar|gz|tgz)$/i;
const EDGE_NOISE = /^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu;
const UNDERSCORES = /_+/g;
const HAS_LETTERS = /\p{L}/u;

// Albums created from an archive inherit the folder name, which is often a
// file name like "+ __23.09.2026_2026-09-23.zip". Such names carry nothing
// beyond the date the UI already shows, so they are dropped.
export const getAlbumDisplayName = (
  name: string | undefined,
): string | null => {
  if (!name) {
    return null;
  }

  const cleaned = name
    .trim()
    .replace(ARCHIVE_EXTENSION, '')
    .replace(UNDERSCORES, ' ')
    .replace(EDGE_NOISE, '')
    .replace(/\s+/g, ' ');

  return HAS_LETTERS.test(cleaned) ? cleaned : null;
};
